import { useMemo } from 'react';
import { TournamentTeamStatus } from '@okletsplay/core';
import { TournamentEntity } from 'app/interfaces/entity';

export const getActiveTeamsCount = (tournament: TournamentEntity) => {
  if (!tournament?.teams) return 0;

  return tournament.teams.filter((team) => team.status !== TournamentTeamStatus.Inactive).length;
};

export const useTournamentTeamDetails = (tournament: TournamentEntity) => {
  const activeTeamsCount = useMemo(() => {
    return getActiveTeamsCount(tournament);
  }, [tournament]);

  return {
    activeTeamsCount,
  };
};

export const getPlayersJoinedWithRewardBalance = (tournament: TournamentEntity) => {
  if (!tournament?.teams?.length) return [];

  return tournament.teams
    .flatMap((team) => team.players)
    .filter((player) => player.details?.isJoinedWithRewardBalance);
};
